import { loading, error } from 'State/actions';
import * as types from './types';
import { submitDelay } from 'Common/GeneralHelper';
import {
  toastErrorFromCatch,
  createToast,
  toastType,
} from 'Common/ToastHelper';

export const getApplicationList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric(`IncomingApplication`);
      dispatch({
        type: types.REVIEW_INCOMING_APPLICATIONS_GET_APPLICATIONS,
        payload: response.data.Data,
      });
    } catch (ex) {
      dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR, ex));
      toastErrorFromCatch(ex, 'Application data could not be loaded.');
    }
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, false));
  };
};

export const deleteIncomingApplication = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, true));
    try {
      await MPWWebApi.postGenericDelete(`IncomingApplication`, id);
      dispatch(getApplicationList());
    } catch (ex) {
      dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR, ex));
      toastErrorFromCatch(
        ex,
        'An error occured while deleting this application.'
      );
    }
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, false));
  };
};

export const deleteIncomingMember = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, true));
    try {
      await MPWWebApi.postGenericDelete(`IncomingApplication/Member`, id);
      dispatch(getApplicationList());
    } catch (ex) {
      dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR, ex));
      toastErrorFromCatch(ex, 'An error occured while deleting this student.');
    }
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, false));
  };
};

export const setIncomingStudentAsMember = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, true));
    try {
      await MPWWebApi.getGeneric(
        `IncomingApplication/SetStudentAsMember/${id}`
      );
      dispatch(getApplicationList());
    } catch (ex) {
      dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR, ex));
      toastErrorFromCatch(ex, 'An error occured while deleting this student.');
    }
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, false));
  };
};

export const saveIncomingApplicationAsNew = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, true));
    try {
      var createdId = (
        await MPWWebApi.getGeneric(
          `IncomingApplication/SaveNewApplication/${id}`
        )
      ).data.Data;

      dispatch(getApplicationList());
      createToast(
        toastType.success,
        'Success',
        `Application ${createdId} Successfully Created.`
      );
    } catch (ex) {
      dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_FETCH_ERROR, ex));
      toastErrorFromCatch(ex, 'An error occured while saving the application.');
    }
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_FETCHING, false));
  };
};

export const syncApplications = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_SET_SYNC_ERROR, null));
    dispatch(loading(types.REVIEW_INCOMING_APPLICATIONS_SET_SYNCLOADING, true));

    try {
      await MPWWebApi.getGeneric('ImportFromLAP');

      //to prevent being able to click a bunch of times in a row while still downloading
      submitDelay(7000).then(() => {
        dispatch(getApplicationList());
        dispatch(
          loading(types.REVIEW_INCOMING_APPLICATIONS_SET_SYNCLOADING, false)
        );
      });
    } catch (ex) {
      dispatch(
        loading(types.REVIEW_INCOMING_APPLICATIONS_SET_SYNCLOADING, false)
      );

      dispatch(error(types.REVIEW_INCOMING_APPLICATIONS_SET_SYNC_ERROR, ex));
    }
  };
};

export const setFilteredData = (filterValue) => {
  return {
    type: types.REVIEW_INCOMING_APPLICATIONS_SET_FILTERED_DATA,
    payload: filterValue,
  };
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/grid/actions.js